import { Component, inject, signal, HostListener, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterModule } from '@angular/router';
import {
  ChevronRightIcon,
  LucideAngularModule,
  ShoppingCartIcon,
} from 'lucide-angular';
import { CartService } from '../../services/cart.service';
import { CartComponent } from './cart-component';
import { PopoverModule } from 'primeng/popover';

@Component({
  selector: 'allas-cart-mini',

  imports: [
    CommonModule,
    RouterModule,
    LucideAngularModule,
    CartComponent,
    PopoverModule,
  ],
  template: `
    <div class="relative">
      <!-- Botón del carrito minimalista -->
      <button
        (click)="popover.show($event)"
        class="xl:p-3 text-gray-700 transition-all duration-200 flex flex-col md:flex-row gap-1 xl:gap-2 min-w-max items-center justify-center group"
        [class.h-10]="isInStickyHeader"
        [class.w-10]="isInStickyHeader"
        [class.h-12]="!isInStickyHeader"
        [class.w-12]="!isInStickyHeader"
        [class.bg-blue-50]="showCart()"
        [class.text-blue-600]="showCart()"
      >
        <span class="relative">
          <img
            src="/allas-icons/cart-nav.svg"
            alt="Carrito"
            class="w-auto h-4 xl:h-6"
          />
          <!-- Badge simple y limpio -->
          @if (cartService.totalItems() > 0) {
          <span
            class="absolute -top-2 -right-2 bg-red-500 text-white text-[10px] xl:text-xs rounded-full w-[14px] xl:w-[18px] h-[14px] xl:h-[18px] flex items-center justify-center scale-110"
          >
            {{
              cartService.totalItems() > 99 ? '99+' : cartService.totalItems()
            }}
          </span>
          }
        </span>
        <span
          class="text-xs xl:text-sm font-light fs-condensed group-hover:text-allasRed"
          [class.hidden]="isInStickyHeader"
        >
          Mi Carrito
        </span>
        <lucide-icon
          [name]="chevronRightIcon"
          class="w-auto h-4 hidden md:block"
        ></lucide-icon>
      </button>
    </div>

    <p-popover #popover [style]="{ width: '300px' }">
      <ng-template pTemplate="content">
        <allas-cart (closeCart)="popover.hide()"></allas-cart>
      </ng-template>
    </p-popover>
  `,
})
export class CartMiniComponent {
  cartService = inject(CartService);
  @Input() isInStickyHeader = false;

  readonly shoppingCartIcon = ShoppingCartIcon;
  readonly chevronRightIcon = ChevronRightIcon;

  showCart = signal(false);

  toggleCart(): void {
    this.showCart.update((show) => !show);
  }

  closeCart(): void {
    this.showCart.set(false);
  }

  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    this.closeCart();
  }
}
